<section class="reportingparent" *ngIf=" rbavalue?.hasAllLocationNotNone==true">
  <div class="reportingheader">Reporting Dashboard</div>

  <div class="filterparent">
    <div class="season">
      <div class="headfilter">Season</div>
      <div class="financial_dropdown seasonopen" [ngClass]="toggleseason ? 'open' : ''">
        <div class="button " (click)="openseason()">

          <span class="seasonyear"><ng-container *ngIf="seasoncount>1;else oneseason">{{seasoncount}} seasons
              selected</ng-container><ng-template #oneseason><ng-container *ngIf="selectedseason[0]=='All seasons'">{{selectedseason[0]}}</ng-container><ng-container *ngIf="selectedseason[0]!='All seasons'">{{selectedseason[0] | seasonspilt}}</ng-container></ng-template>
          </span>

        </div>
        <ul class="select-list" [ngClass]="toggleseason ? 'open' : ''">
          <li class="clsAnchor" *ngFor="let season of seasonObjects">
            <label><input type="checkbox" class="registration_checkbox" value={{season.season}}
                [(ngModel)]="season.checked" (click)="seasonchange($event);applyfilter()"> <span
                class="checkbox-button__control"></span><ng-container
                *ngIf="season.season=='All seasons';else seasonvalue">{{season.season}}</ng-container><ng-template
                #seasonvalue>{{season.season | seasonspilt}}</ng-template></label>

          </li>
          <li class="reset" (click)="seasonrest();applyfilter()">RESET</li>
        </ul>
      </div>
    </div>
    <div class="view">
      <div class="headfilter">View</div>
      <div class="financial_dropdown" [ngClass]="toggleview ? 'open' : ''">

        <div class="button viewopen" (click)="openview()">

          <span class="seasonyear">{{selectedOption}}
          </span>

        </div>
        <ul class="select-list" [ngClass]="toggleview ? 'open' : ''">
          <li class="clsAnchor" *ngFor="let view of view">
            <label><input type="radio" class="registration_radio" [checked]="view === 'All'"
                [(ngModel)]="selectedOption" name="radiobtn" value={{view}} (ngModelChange)="applyfilter()"> <span
                class="radio-button__control"></span>{{view}}</label>

          </li>
          <li class="reset" (click)="resetview();applyfilter()">RESET</li>
        </ul>
      </div>
    </div>
    <div class="delivery">
      <div class="headfilter">Delivery Address</div>
      <div class="financial_dropdown" [ngClass]="toggledelivery ? 'open' : ''">

        <div class="button deliveryopen" (click)="opendelivery()">

          <span class="seasonyear"><ng-container *ngIf="deliverycount>1;else onedelivery">{{deliverycount}} deliveries
            selected</ng-container><ng-template #onedelivery><ng-container *ngIf="selecteddelivery[0]=='All'">{{selecteddelivery[0]}}</ng-container><ng-container *ngIf="selecteddelivery[0]!='All'">{{selecteddelivery[0]}}</ng-container></ng-template>
        </span>
          

        </div>
        <ul class="select-list" [ngClass]="toggledelivery ? 'open' : ''">
          <li class="clsAnchor" *ngFor="let delivery of deliveryObjects">
            <label><input type="checkbox" class="registration_checkbox" value={{delivery.delivery}}
                [(ngModel)]="delivery.checked" (click)="changedelivery($event);applyfilter()"> <span
                class="checkbox-button__control"></span>{{delivery.delivery}}</label>

          </li>
          <li class="reset" (click)="deliveryreset();applyfilter()">RESET</li>
        </ul>
      </div>
    </div>
  </div>


  <section class="chartcontainer no-padding" *ngIf="(obj?.dashboardReportingData?.length ?? 0) > 0 && (filteredData1?.length ?? 0) > 0">
    <div class="orderchart" [ngClass]="selectedOption=='All' || selectedOption=='Order'?'':'hideorder'">
      <div class="titlegraph col-xs-12 no-padding">
        <div class="titletext no-padding-left">Orders by Season</div>
        <div class="legends no-padding-right">
          <div class="productledengs">
          <div class="product2box"></div>
          <div class="productname productspace">{{productname1Display}}</div>
        </div>
<div class="productledengs">
          <div class="product1box"></div>
          <div class="productname">{{productname2Display}}</div>
        </div>
        </div>
      </div>
      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" style="width: 100%; display: block;">
      </highcharts-chart>
    </div>
    <div class="returnchart" [ngClass]="selectedOption=='All' || selectedOption=='Return'?'':'hideorder'">
      <div class="titlegraph col-xs-12 no-padding">
        <div class="titletext  no-padding-left">Returns by Season</div>
        <div class="legends  no-padding-right">
          <div class="productledengs">
          <div class="product2box"></div>
          <div class="productname productspace">{{productname1Display}}</div>
        </div>
<div class="productledengs">
          <div class="product1box"></div>
          <div class="productname">{{productname2Display}}</div>
        </div>
        </div>
      </div>
      <highcharts-chart [Highcharts]="Highchartsreturn" [options]="chartOptionsreturn"
        style="width: 100%; display: block;">
      </highcharts-chart>
    </div>
  </section>
  <section class="mattablesection" *ngIf="(obj?.dashboardReportingData?.length ?? 0) > 0 && (filteredData1?.length ?? 0) > 0">
    <table mat-table *ngIf="selectedOption=='All'" class="table reporting-details-table" [dataSource]="dataSource">

      <ng-container matColumnDef="Season">
        <th mat-header-cell *matHeaderCellDef>Season </th>
        <td mat-cell *matCellDef="let element"> {{element.season}} </td>
      </ng-container>

      <ng-container matColumnDef="Location Name">
        <th mat-header-cell *matHeaderCellDef>Location Name </th>
        <td mat-cell *matCellDef="let element"> {{element.locationName}} </td>
      </ng-container>

      <ng-container matColumnDef="Postcode">
        <th mat-header-cell *matHeaderCellDef>Postcode</th>
        <td mat-cell *matCellDef="let element">{{element.postcode}}</td>
      </ng-container>

      <ng-container matColumnDef="Orders - aTIV">
        <th mat-header-cell *matHeaderCellDef>Orders - {{productname1}}</th>
        <td mat-cell *matCellDef="let element"> 
          <ng-container *ngIf="element?.products?.length>1;else oneproduct">
            <span
              *ngIf="element?.products[0]?.productName=='aQIV' || element?.products[0]?.productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.orderQuantity}} </span>
          </ng-container><ng-template #oneproduct><span
              *ngIf="element?.products[0]?.productName=='aQIV' || element?.products[0].productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.orderQuantity}} </span></ng-template>
        </td>

      </ng-container>
      <ng-container matColumnDef="Orders - TIVc">
        <th mat-header-cell *matHeaderCellDef>Orders - {{productname2}}</th>
        <td mat-cell *matCellDef="let element"> 
          <ng-container *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[1]?.productName=='QIVc' || element?.products[1]?.productName=='TIVc'">{{element?.products[1].orderQuantity}} </span>
          </ng-container>
          <ng-template #oneproductqiv><span
              *ngIf="element?.products[0]?.productName=='QIVc' || element?.products[0]?.productName=='TIVc'">{{element?.products[0].orderQuantity}} </span></ng-template>
        </td>

      </ng-container>
      <ng-container matColumnDef="Returns - aTIV">
        <th mat-header-cell *matHeaderCellDef>Returns - {{productname1}}</th>
        <td mat-cell *matCellDef="let element"> <ng-container
            *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[0].productName=='aQIV' || element?.products[0].productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.returnQuantity}}</span>
          </ng-container><ng-template #oneproductqiv><span
              *ngIf="element?.products[0].productName=='aQIV' || element?.products[0].productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.returnQuantity}}</span></ng-template>
        </td>

      </ng-container>
      <ng-container matColumnDef="Returns - TIVc">
        <th mat-header-cell *matHeaderCellDef>Returns - {{productname2}}</th>
        <td mat-cell *matCellDef="let element"> <ng-container
            *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[1].productName=='QIVc' || element?.products[1].productName=='TIVc'">{{element?.products[1]?.returnQuantity}}</span>
          </ng-container><ng-template #oneproductqiv><span
              *ngIf="element?.products[0].productName=='QIVc' || element?.products[0].productName=='TIVc'">{{element?.products[0]?.returnQuantity}}</span></ng-template>
        </td>

      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- order only -->
    <table mat-table *ngIf="selectedOption=='Order'" class="table fivecolumn reporting-details-table"
      [dataSource]="dataSource">

      <ng-container matColumnDef="Season">
        <th mat-header-cell *matHeaderCellDef>Season </th>
        <td mat-cell *matCellDef="let element"> {{element.season}} </td>
      </ng-container>

      <ng-container matColumnDef="Location Name">
        <th mat-header-cell *matHeaderCellDef>Location Name </th>
        <td mat-cell *matCellDef="let element"> {{element.locationName}} </td>
      </ng-container>

      <ng-container matColumnDef="Postcode">
        <th mat-header-cell *matHeaderCellDef>Postcode</th>
        <td mat-cell *matCellDef="let element">{{element.postcode}}</td>
      </ng-container>

      <ng-container matColumnDef="Orders - aTIV">
        <th mat-header-cell *matHeaderCellDef>Orders - {{productname1}} </th>
        <td mat-cell *matCellDef="let element"> <ng-container *ngIf="element?.products?.length>1;else oneproduct"><span
              *ngIf="element?.products[0]?.productName=='aQIV' || element?.products[0]?.productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.orderQuantity}}</span>
          </ng-container><ng-template #oneproduct><span
              *ngIf="element?.products[0]?.productName=='aQIV' || element?.products[0]?.productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.orderQuantity}}</span></ng-template>
        </td>

      </ng-container>
      <ng-container matColumnDef="Orders - TIVc">
        <th mat-header-cell *matHeaderCellDef>Orders - {{productname2}}</th>
        <td mat-cell *matCellDef="let element"> <ng-container
            *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[1].productName=='QIVc' || element?.products[1].productName=='TIVc'">{{element?.products[1]?.orderQuantity}}</span>
          </ng-container><ng-template #oneproductqiv><span
              *ngIf="element?.products[0].productName=='QIVc' || element?.products[0].productName=='TIVc'">{{element?.products[0]?.orderQuantity}}</span></ng-template>
        </td>

      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsorders"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsorders;"></tr>
    </table>

    <!-- return only -->
    <table *ngIf="selectedOption=='Return'" mat-table class="table fivecolumn reporting-details-table"
      [dataSource]="dataSource">

      <ng-container matColumnDef="Season">
        <th mat-header-cell *matHeaderCellDef>Season </th>
        <td mat-cell *matCellDef="let element"> {{element.season}} </td>
      </ng-container>

      <ng-container matColumnDef="Location Name">
        <th mat-header-cell *matHeaderCellDef>Location Name </th>
        <td mat-cell *matCellDef="let element"> {{element.locationName}} </td>
      </ng-container>

      <ng-container matColumnDef="Postcode">
        <th mat-header-cell *matHeaderCellDef>Postcode</th>
        <td mat-cell *matCellDef="let element">{{element.postcode}}</td>
      </ng-container>
      <ng-container matColumnDef="Returns - aTIV">
        <th mat-header-cell *matHeaderCellDef>Returns - {{productname1}} </th>
        <td mat-cell *matCellDef="let element"> <ng-container
            *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[0].productName=='aQIV' || element?.products[0].productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.returnQuantity}}</span>
          </ng-container><ng-template #oneproductqiv><span
              *ngIf="element?.products[0].productName=='aQIV' || element?.products[0].productName=='aTIV' || element?.products[0]?.productName=='Auje'">{{element?.products[0]?.returnQuantity}}</span></ng-template>
        </td>

      </ng-container>
      <ng-container matColumnDef="Returns - TIVc">
        <th mat-header-cell *matHeaderCellDef>Returns - {{productname2}}</th>
        <td mat-cell *matCellDef="let element"> <ng-container
            *ngIf="element?.products?.length>1;else oneproductqiv"><span
              *ngIf="element?.products[1].productName=='QIVc' || element?.products[1].productName=='TIVc'">{{element?.products[1]?.returnQuantity}}</span>
          </ng-container><ng-template #oneproductqiv><span
              *ngIf="element?.products[0].productName=='QIVc' || element?.products[0].productName=='TIVc'">{{element?.products[0]?.returnQuantity}}</span></ng-template>
        </td>

      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumnsreturn"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsreturn;"></tr>
    </table>
  </section>
  <section class="csvsection" *ngIf="(obj?.dashboardReportingData?.length ?? 0) > 0 && (filteredData1?.length ?? 0) > 0">
    <button class="csvbutton" (click)="handleoncsv()">Export Table as CSV File </button>

  </section>
  <div class="norecord" *ngIf="(obj?.dashboardReportingData?.length ?? 0) === 0 || (filteredData1?.length ?? 0) === 0">No records found.</div>
<!--   <div class="norecord" *ngIf=" rbavalue?.hasAllLocationNotNone==false"></div>
 -->
</section>
<section class="reportingparent" *ngIf=" rbavalue?.hasAllLocationNotNone==false">
  <div class="reportingheader">Reporting Dashboard</div>
  <div class="permissionnone">You currently do not have permission to view this. Please contact your account admin or Seqirus customer service.</div>
 </section>